import { gtmFunctions } from '../../../../../constants/analytics/GTM';

export default function useCallGtm({ gtm, gtmProps }) {
  return {
    callGtm() {
      gtmFunctions[gtm]?.(gtmProps);
    },
  };
}
